import React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { HasPermissions, Button } from "components";
import { permissionList } from "helpers";
import { uiActions } from "store";

let ApplicationsActions = () => {
	const history = useHistory();

	const dispatch = useDispatch();

	const handleStartApplication = () => {
		dispatch(
			uiActions.showModal("CONFIRMATION", {
				buttonOk: "Ok",
				title: [
					"Use this option if you want to create an application through Rise to be signed by the merchant electronically and you do not already have a signed MPA.",
					"",
					"If you already have a signed MPA, please cancel and select 'MPA Upload'.",
				],
				onConfirm() {
					history.push("/applications/entry");
				},
			}),
		);
	};

	const handleStartMpaUploadApplication = () => {
		dispatch(
			uiActions.showModal("CONFIRMATION", {
				buttonOk: "Ok",
				title: [
					"Use this option if you already have a signed MPA.",
					"",
					"If you do not have a signed MPA, and want to create an application through Rise to be signed electronically, please cancel and select 'Start electronic app'.",
				],
				onConfirm() {
					history.push("/applications/upload-mpa/general-info");
				},
			}),
		);
	};

	const handleShowSendPreAppModal = () => {
		dispatch(uiActions.showModal("SEND_PRE_APP"));
	};

	return (
		<>
			<HasPermissions
				requiredPermissions={permissionList.StartNewApplication}
			>
				<Button
					onClick={handleStartApplication}
					value="Start electronic app"
				/>
				<Button
					type="button"
					className="ml-4"
					onClick={handleStartMpaUploadApplication}
					variant="outline-primary"
					value="Mpa upload"
				/>
			</HasPermissions>
			<Button
				type="button"
				className="ml-4"
				onClick={handleShowSendPreAppModal}
				variant="outline-primary"
				value="Send pre-application"
			/>
		</>
	);
};

export default ApplicationsActions;
